import { addTrailer } from 'actions/addVehicle'
import { navigateToSearchByTireSizes } from 'actions/shopByTires'
import { clearCompareItems } from 'components/OneColumnSearchResultPage/actions'
import { extractSizes } from 'helpers/createTireSizeString'
import { SEARCH_TIRES_PURPOSE_TRAILER } from './constants'

export const findTires = ({ tireSize, purpose, queryParams }) => async dispatch => {
  const isTrailer = purpose === SEARCH_TIRES_PURPOSE_TRAILER

  if (isTrailer) {
    const { tireFrontSize, tireRearSize } = extractSizes(tireSize)
    await dispatch(addTrailer({
      TireSize: tireFrontSize,
      RearTireSize: tireRearSize
    }))
  }

  dispatch(clearCompareItems())
  dispatch(navigateToSearchByTireSizes(tireSize, queryParams, isTrailer))
}
